/**
 * VapeCity STI — PostHog Custom Events
 * Tracks user interactions to optimize conversions
 */

(function () {
  if (typeof posthog === 'undefined') return;

  // ─── Product card clicks ───────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var card = e.target.closest('product-card-link, a[href*="/products/"]');
    if (!card) return;

    var section = card.closest('[data-section-type], .section-resource-list');
    var collectionTitle = '';
    if (section) {
      var heading = section.querySelector('h2, h3, .collection-title');
      if (heading) collectionTitle = heading.innerText.trim();
    }

    var title = card.getAttribute('aria-label') || card.innerText.trim().split('\n')[0] || '';
    var price = '';
    var priceEl = card.closest('.resource-list__item')?.querySelector('.price');
    if (priceEl) price = priceEl.innerText.trim();

    posthog.capture('product_clicked', {
      product_title: title,
      product_price: price,
      collection: collectionTitle,
      page: window.location.pathname
    });
  });

  // ─── "Ver todo" / "View all" collection links ──────────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link) return;
    var text = link.innerText.trim().toLowerCase();
    if (text === 'view all' || text === 'ver todo' || text === 'ver todos') {
      var section = link.closest('.section-resource-list');
      var collectionTitle = '';
      if (section) {
        var heading = section.querySelector('h2, h3');
        if (heading) collectionTitle = heading.innerText.trim();
      }
      posthog.capture('collection_view_all_clicked', {
        collection: collectionTitle,
        href: link.href
      });
    }
  });

  // ─── Add to cart ───────────────────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;

    var titleEl = form.closest('[data-product-title]') ||
                  document.querySelector('h1.product__title, h1[itemprop="name"]');
    var title = titleEl ? titleEl.getAttribute('data-product-title') || titleEl.innerText.trim() : '';
    var price = '';
    var priceEl = form.closest('.product-form-wrapper, section')?.querySelector('.price__current, .price');
    if (priceEl) price = priceEl.innerText.trim();

    posthog.capture('add_to_cart', {
      product_title: title,
      product_price: price,
      page: window.location.pathname
    });
  });

  // ─── Cart icon click ───────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-icon], cart-icon, .cart-icon')) {
      posthog.capture('cart_opened');
    }
  });

  // ─── Search ────────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-action="open-search"], .search-modal__toggle, button[aria-label*="earch"]')) {
      posthog.capture('search_opened');
    }
  });

  // ─── WhatsApp float (delegated — button may not exist yet) ────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('#whatsapp-float')) {
      posthog.capture('whatsapp_clicked', {
        source: 'float_button',
        page: window.location.pathname
      });
    }
  });

  // ─── Hero click ────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('.hero__link, .hero__cta-btn')) {
      posthog.capture('hero_clicked', {
        page: window.location.pathname
      });
    }
  });

  // ─── Email signup ──────────────────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    if (e.target.closest('form[action*="customer/register"], form[action*="contact"], .email-signup')) {
      posthog.capture('email_signup_submitted', {
        page: window.location.pathname
      });
    }
  });

  // ─── Scroll depth (25, 50, 75, 100%) ──────────────────────────────────────
  var depthsTracked = {};
  window.addEventListener('scroll', function () {
    var scrolled = window.scrollY + window.innerHeight;
    var total = document.documentElement.scrollHeight;
    var pct = Math.round((scrolled / total) * 100);
    [25, 50, 75, 100].forEach(function (depth) {
      if (pct >= depth && !depthsTracked[depth]) {
        depthsTracked[depth] = true;
        posthog.capture('scroll_depth', { depth: depth, page: window.location.pathname });
      }
    });
  }, { passive: true });

})();
